import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Input,
} from "@mui/material";
import kazanimg from "../../../Assets/a_20.png";
import "../../CSS/CrownCss/CKazanSistemi.css";

const kazanData = [
  {
    id: 1,
    kumanda: "Start",
    calismaDurumu: "Start",
    arizaDurumu: "Normal",
    yuksekSicaklik: "Normal",
    isitmaGidis: "80.0(°C)",
    isitmaDonus: "60.0(°C)",
    kapasite: "80.0%",
    calismaZamani: "2570.0 hr",
  },
  {
    id: 2,
    kumanda: "Start",
    calismaDurumu: "Start",
    arizaDurumu: "Normal",
    yuksekSicaklik: "Normal",
    isitmaGidis: "80.0(°C)",
    isitmaDonus: "60.0(°C)",
    kapasite: "80.0%",
    calismaZamani: "2570.0 hr",
  },
  {
    id: 3,
    kumanda: "Stop",
    calismaDurumu: "Start",
    arizaDurumu: "Normal",
    yuksekSicaklik: "Normal",
    isitmaGidis: "45.0(°C)",
    isitmaDonus: "60.0(°C)",
    kapasite: "80.0%",
    calismaZamani: "2570.0 hr",
  },
];

const additionalData = {
  kontrolModu: "Start",
  kumanda: "Start",
  setSicaklik: "80(°C)",
};

const CKazanSistemi = () => {
  return (
    <div className="container-kazan">
      <div className="kazan-system">
        {kazanData.map((kazan) => (
          <div className="kazan-container" key={kazan.id}>
            <img
              src={kazanimg}
              className="kazan-img"
              alt={`Kazan ${kazan.id}`}
            />
            <h4>KAZAN - {kazan.id}</h4>
            <div className="kazan-table">
              <p className="title">Kazan-{kazan.id} Durumu</p>
              <div className="row">
                <p>Kumanda</p>
                <div className={`kazan${kazan.id}-kumanda`}>
                  {kazan.kumanda}
                </div>
              </div>
              <div className="row">
                <p>Çalışma Durumu</p>
                <div className="kazan-calisma-durumu">
                  {kazan.calismaDurumu}
                </div>
              </div>
              <div className="row">
                <p>Arıza Durumu</p>
                <div className="kazan-ariza-durumu">{kazan.arizaDurumu}</div>
              </div>
              <div className="row">
                <p>Yüksek Sıcaklık Alarmı</p>
                <div className="kazan-yuksek-sicaklik">
                  {kazan.yuksekSicaklik}
                </div>
              </div>
              <div className="row">
                <p>Isıtma Gidiş Kollektörü</p>
                <div className="kazan-ısıtma-gidis">{kazan.isitmaGidis}</div>
              </div>
              <div className="row">
                <p>Isıtma Dönüş Kollektörü</p>
                <div className="kazan-ısıtma-donus">{kazan.isitmaDonus}</div>
              </div>
              <div className="row">
                <p>Kazan Kapasite</p>
                <div className="kazan-kapasite">{kazan.kapasite}</div>
              </div>
              <div className="row">
                <p>Çalışma Zamanı</p>
                <div className="kazan-calisma-zamani">
                  {kazan.calismaZamani}
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className="additional-container">
          <div className="kazan-table">
            <p className="title">Sistem Durumu</p>
            <div className="row">
              <p>Kontrol Modu</p>
              <div className="kontrol-modu">{additionalData.kontrolModu}</div>
            </div>
            <div className="row">
              <p>Kumanda</p>
              <div className="kumanda">{additionalData.kumanda}</div>
            </div>
            <div className="row">
              <p>Set Sıcaklık</p>
              <div className="set-sicaklik">{additionalData.setSicaklik}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CKazanSistemi;
